import axios from 'axios';

// Always append /api programmatically so platform env resets can't break routing
const BASE_URL = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/api\/?$/, '');
const API_URL = `${BASE_URL}/api`;

// Helper to construct asset URLs (images, uploads) - prevents double /api/api/ bug
export const getAssetUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('http')) return path;
  // Strip leading /api if present to prevent double prefix
  const cleanPath = path.replace(/^\/api/, '');
  return `${BASE_URL}${cleanPath.startsWith('/') ? '' : '/'}${cleanPath}`;
};

// Export BASE_URL for components that need direct access
export { BASE_URL };

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Dynamically attach token from localStorage on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || '';
      const isAuthRequest = requestUrl.includes('/auth/login');
      if (!isAuthRequest) {
        // Token expired or invalid
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
